import { generateQueryParams } from '@xmatters/redux/services/util';

export const GENERATE_AUTH_CODE = 'GENERATE_AUTH_CODE';
export const GENERATE_AUTH_CODE_START = `${GENERATE_AUTH_CODE}_START`;
export const GENERATE_AUTH_CODE_SUCCESS = `${GENERATE_AUTH_CODE}_SUCCESS`;
export const GENERATE_AUTH_CODE_FAIL = `${GENERATE_AUTH_CODE}_FAIL`;

export function generateAuthCode(payload) {
  return {
    type: GENERATE_AUTH_CODE,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/oauth2/authorize',
      method: 'post',
      isUriEncoded: true,
      params: generateQueryParams(payload),
      contentType: 'application/x-www-form-urlencoded',
    },
  };
}

export function generateSlackBotAuthCode(payload) {
  const requestPayload = {
    ...payload,
    client_id: 'slackbot',
    response_type: 'code',
  };
  return generateAuthCode(requestPayload);
}
